import { Component, OnInit } from '@angular/core';
import { CRUD, Environment } from '../../config/environment';
import { AlertModel, ALERT_TYPE } from '../shared/alert/alert.component';
import { AplicanteAdicionalModel, BusquedaFiltrosModel } from 'src/app/models/aplicante.model';
import { CanceladosService } from '../../services/cancelados/cancelados.service';
import { CommonDataService } from 'src/app/services/commons/commondata.service';
import { SessionStorageService } from 'src/app/auth/services/session.service';
import { Utils } from 'src/app/commons/utils';
import { AccionAplicanteList, GenerosList, MotivosAplicanteList, NacionalidadesList, ProductosList, ProfesionesList, ProvinciasList, SourceCodesList, TiposDocumentosList, TrabajosTipolList, VinculosList } from 'src/app/models/lists.model';
import * as moment from 'moment';
declare var $: any;

@Component({
  selector: 'app-cancelados',
  templateUrl: './cancelados.component.html',
  styleUrls: ['./cancelados.component.css']
})
export class CanceladosComponent implements OnInit {

  public title: string = "CANCELADOS";
  public es: any;
  public showResult: boolean = false;
  public showDetail: boolean = false;
  public loading: boolean = false;
  public alertMessage: AlertModel = new AlertModel;
  public alertConfirmEvent: Function;
  public resultsData: Array<any> = [];
  public busquedafiltros: BusquedaFiltrosModel = new BusquedaFiltrosModel;
  public tablereports = null;
  public aplicanteCurrent: any = {};
  public accionList: AccionAplicanteList = new AccionAplicanteList();
  public motivosList: MotivosAplicanteList = new MotivosAplicanteList();
  public productosList: ProductosList = new ProductosList();
  public profesionesList: ProfesionesList = new ProfesionesList();
  public trabajosTipolList: TrabajosTipolList = new TrabajosTipolList();
  public estadoCivilList: Array<any> = [];
  public nacionalidadesList: NacionalidadesList = new NacionalidadesList();
  public provinciasList: ProvinciasList = new ProvinciasList();
  public loadingMotivo: boolean = false;
  public sourcecodesList: SourceCodesList = new SourceCodesList();
  public objSc: any;
  public productOk: boolean = true;
  public messagetrackingshow: boolean = false;
  public showAdicionalesEditar: boolean = false;
  public adicionalCurrent: AplicanteAdicionalModel = new AplicanteAdicionalModel;
  public adicionalCurrentBk: AplicanteAdicionalModel = new AplicanteAdicionalModel;
  public validationsAdicional: Array<any> = new Array<any>();
  public validationsAdicionalShow: boolean = false;
  public tiposDocumentosList: TiposDocumentosList = new TiposDocumentosList();
  public vinculosList: VinculosList = new VinculosList();
  public generosList: GenerosList = new GenerosList();

  constructor(
    private canceladosService: CanceladosService,
    private commonDataService: CommonDataService,
    private sessionStorageService: SessionStorageService
  ) {
  }

  ngOnInit() {
    this.setCalendarLocale();
    this.loadAcciones();
    this.loadEstadoCivil();
    this.loadProductos();
    this.loadSourcecodes();
    this.loadParameters();
  }

  setCalendarLocale() {
    this.es = Environment.CalendarLanguageSetting;
  }

  loadAcciones() {
    this.canceladosService.getValidationAccion().subscribe(
      (data: any) => {
        if (data && data['data']) {
          this.accionList.data = data['data'].filter(a => a.key !== 'CANCELADO');
        }
      }
    );
  }

  accionChange(accion: string) {
    this.loadingMotivo = true;
    this.aplicanteCurrent.validacion.motivo = '';

    if (!accion) {
      this.motivosList.data = [];
      this.loadingMotivo = false;
      return;
    }

    let request = { "parent": accion };

    this.canceladosService.getValidationMotivo(request).subscribe(
      (data: any) => {
        if (data && data['data']) {
          this.motivosList.data = data['data'];

          let motivo = this.motivosList.data.find(a => a.key == this.aplicanteCurrent.validacion.motivo);
          if (motivo == null) {
            this.aplicanteCurrent.validacion.motivo = '';
          }

          this.motivosList.data.sort((a, b) => a.key?.localeCompare(b.key));
        } else {
          this.motivosList.data = [];
        }
        this.loadingMotivo = false;
      },
      error => {
        console.error(error);
        this.motivosList.data = [];
        this.loadingMotivo = false;
      }
    );
  }

  setDateFormat(value: Date) {
    return Utils.setDateFormat(value);
  }

  loadReportResults() {
    if (Utils.dateIsValid(this.busquedafiltros.fechaDesde) &&
      Utils.dateIsValid(this.busquedafiltros.fechaHasta)) {
      let cap_days = Utils.dateDiffBetween(this.busquedafiltros.fechaDesde, this.busquedafiltros.fechaHasta, "days");
      if (cap_days < 0) {
        this.alertMessage = new AlertModel("Fecha: Desde debe ser mayor que Hasta.", this.title, true);
        return;
      }
    }

    this.loading = true;
    this.showResult = false;

    let request = {
      "matriz": this.sessionStorageService.getCurrentUser()?.matriz,
      "dni": Utils.isNullOrEmpty(this.busquedafiltros.dni) ? null : this.busquedafiltros.dni,
      "nombreapellido": Utils.isNullOrEmpty(this.busquedafiltros.nombre) ? null : this.busquedafiltros.nombre,
      "pcn": Utils.isNullOrEmpty(this.busquedafiltros.pcn) ? null : this.busquedafiltros.pcn,
      "cuil": Utils.isNullOrEmpty(this.busquedafiltros.cuil) ? null : this.busquedafiltros.cuil,
      "fechaDesde": Utils.isNullOrEmpty(this.busquedafiltros.fechaDesde) ? null : this.busquedafiltros.fechaDesde,
      "fechaHasta": Utils.isNullOrEmpty(this.busquedafiltros.fechaHasta) ? null : this.busquedafiltros.fechaHasta,
    };

    this.canceladosService.getApplicantsReportByArea(request).subscribe(
      data => {
        if (data['data']) {
          this.resultsData = data['data'];
          this.setupTable();
        } else {
          this.resultsData = [];
          this.alertMessage = new AlertModel("Hubo un inconveniente al obtener la información, inténtalo nuevamente.", this.title, true);
          this.loading = false;
        }
      },
      error => {
        console.error(error);
        this.resultsData = [];
        this.alertMessage = new AlertModel("Hubo un inconveniente al obtener la información, inténtalo nuevamente.", this.title, true);
        this.loading = false;
      }
    );
  }

  private setupTable() {
    this.showResult = true;
    this.loading = false;

    if (this.tablereports != null) {
      this.tablereports.clear().destroy();
    }

    $(document).ready(() => {
      this.tablereports = $("#result-table-cancelados").DataTable({
        searching: true,
        paging: true,
        lengthChange: false,
        pageLength: 10,
        pagingType: 'full_numbers',
        columnDefs: [
          { targets: 'no-sort', orderable: false }
        ],
        language: Environment.DataTableLanguageSetting
      });
    });
  }

  public onKey(e) {
    if (e.keyCode == 13) {
      this.loadReportResults();
    }
  }

  showAplicante(pcn: string) {
    this.loading = true;
    let request = { "pcn": pcn };

    this.canceladosService.getApplicantDetail(request).subscribe(
      data => {
        if (data && data['data'] && data['data'].length > 0) {
          this.aplicanteCurrent = data['data'][0];
          // Inicializar objetos si no existen
          if (!this.aplicanteCurrent.observaciones) {
            this.aplicanteCurrent.observaciones = { observacion: '' };
          } else {
            this.aplicanteCurrent.observaciones.observacion = '';
          }
          if (!this.aplicanteCurrent.validacion) {
            this.aplicanteCurrent.validacion = { accion: '', motivo: '' };
          }
          // Guardar la validacion original para enviar al backend si no se cambia
          this.aplicanteCurrent.validacionOriginal = { 
            accion: this.aplicanteCurrent.validacion.accion, 
            motivo: this.aplicanteCurrent.validacion.motivo 
          };
          // Si el estado actual es CANCELADO, resetear para que elija uno nuevo en el UI
          if (this.aplicanteCurrent.validacion.accion === 'CANCELADO') {
            this.aplicanteCurrent.validacion.accion = '';
            this.aplicanteCurrent.validacion.motivo = '';
          }
          // Cargar motivos si ya tiene acción
          if (this.aplicanteCurrent.validacion.accion) {
            let accion = this.accionList.data.find(a => a.key == this.aplicanteCurrent.validacion.accion);
            if (accion) {
              this.accionChange(this.aplicanteCurrent.validacion.accion);
            } else {
              this.accionList.data.push({
                "key": this.aplicanteCurrent.validacion.accion,
                "value": this.aplicanteCurrent.validacion.accion
              });
              this.motivosList.data.push({
                "key": this.aplicanteCurrent.validacion.motivo,
                "value": this.aplicanteCurrent.validacion.motivo,
                "parent": this.aplicanteCurrent.validacion.accion
              });
            }
          }
          this.showDetail = true;
          this.showResult = false;
          this.sourcecodesForApplicant();
          this.direccionBinding();
        } else {
          this.alertMessage = new AlertModel("No se pudieron obtener los datos.", this.title, true);
        }
        this.loading = false;
      },
      error => {
        console.error(error);
        this.alertMessage = new AlertModel("Hubo un inconveniente al obtener la información.", this.title, true);
        this.loading = false;
      }
    );
  }

  backToResults() {
    this.showDetail = false;
    this.showResult = true;
  }

  confirmSave() {
    if (!this.productOk) {
      this.alertMessage = new AlertModel("No existe sourcecode para el producto seleccionado.", this.title, true, "WARNING");
      return;
    }
    if (!this.aplicanteCurrent.validacion || !this.aplicanteCurrent.validacion.accion) {
      this.alertMessage = new AlertModel("Debe seleccionar una acción.", this.title, true);
      return;
    }
    if (!this.aplicanteCurrent.validacion.motivo) {
      this.alertMessage = new AlertModel("Debe seleccionar un motivo.", this.title, true);
      return;
    }

    this.loading = true;

    let aplicante: any = new Object;
    aplicante.usuario = this.sessionStorageService.getCurrentUser()?.username;
    aplicante.promotor = this.sessionStorageService.getCurrentUser()?.promotor;
    aplicante.solicitud_tarjeta = this.aplicanteCurrent.solicitud_tarjeta;
    aplicante.datos_personales = this.aplicanteCurrent.datos_personales;
    aplicante.datos_contacto = this.aplicanteCurrent.datos_contacto;
    aplicante.datos_laborales = this.aplicanteCurrent.datos_laborales;
    aplicante.detalles = this.aplicanteCurrent.detalles;
    aplicante.datos_precheck = this.aplicanteCurrent.datos_precheck || {};
    aplicante.adicionales = this.aplicanteCurrent.adicionales || [];
    aplicante.observaciones = this.aplicanteCurrent.observaciones;
    aplicante.validacion = this.aplicanteCurrent.validacion;

    this.canceladosService.saveApplicant(aplicante).subscribe(
      data => {
        if (data && data['code'] == '0') {
          this.alertMessage = new AlertModel("Los datos se guardaron con éxito.", this.title, true);
          this.showDetail = false;
          this.showResult = true;
          this.loadReportResults();
        } else {
          this.alertMessage = new AlertModel("Hubo un inconveniente al guardar.", this.title, true);
        }
        this.loading = false;
      },
      error => {
        console.error(error);
        this.alertMessage = new AlertModel("Hubo un inconveniente al guardar.", this.title, true);
        this.loading = false;
      }
    );
  }

  loadEstadoCivil() {
    this.commonDataService.getEstadoCivil().subscribe(
      response => {
        if (response.status == 200 && response.body != null) {
          this.estadoCivilList = Object.assign([], response.body);
        }
      }, err => {
        console.log("Error obteniendo los estados civil");
      }
    );
  }

  loadProductos() {
    this.commonDataService.getProductos().subscribe(
      data => {
        if (data['code'] == "0" && data['data']) {
          this.productosList.data = Object.assign([], data['data']);
        }
      }, err => {
        console.log("Error obteniendo los productos");
      }
    );
  }

  loadParameters() {
    this.commonDataService.getProfesiones().subscribe(
      data => {
        if (data['data']) {
          this.profesionesList.data = data['data'];
          this.profesionesList.data.sort((a, b) => a.value?.localeCompare(b.value));
        }
      }, err => {
        console.log("Error obteniendo las profesiones");
      }
    );
  }

  loadSourcecodes() {
    this.commonDataService.getSourcecodes().subscribe(
      data => {
        if (data['code'] == "0" && data['data']) {
          this.sourcecodesList.data = Object.assign([], data['data']);
          this.sourcecodesList.data = this.sourcecodesList.data.filter(d => d.estado.toUpperCase() == "ACTIVO");
        }
        // Si ya hay un aplicante cargado, actualizar la descripción del sourcecode
        if (this.showDetail && this.aplicanteCurrent?.solicitud_tarjeta) {
          this.sourcecodesForApplicant();
        }
      },
      err => {
        console.log("Error obteniendo los sourcecodes");
      }
    );
  }

  public sourcecodesForApplicant() {
    let source = this.sourcecodesList.data.find(s => s.source_code_completo == this.aplicanteCurrent.solicitud_tarjeta.application_source);

    if (source != null) {
      this.aplicanteCurrent.detalles.subChannel = source.subchannel;
      this.aplicanteCurrent.detalles.sourceCode = source.source_code_completo;
      this.aplicanteCurrent.detalles.sourceCodeDescripcion = source.descripcion;
      this.objSc = source;
      this.productOk = true;
    } else {
      this.aplicanteCurrent.detalles.subChannel = "";
      this.aplicanteCurrent.detalles.sourceCode = "";
      this.aplicanteCurrent.detalles.sourceCodeDescripcion = "";
      this.objSc = { "descripcion": "" };
      this.productOk = false;
    }
  }

  direccionBinding() {
    let direccion = (this.aplicanteCurrent.datos_personales.calle || "") + ' ' +
      (this.aplicanteCurrent.datos_personales.calle_nro || "") + ' ' +
      (this.aplicanteCurrent.datos_personales.calle_piso || "") + ' ' +
      (this.aplicanteCurrent.datos_personales.calle_dpto || "");

    this.aplicanteCurrent.datos_personales.direccion = direccion;
  }

  messageTrackingShow() {
    this.messagetrackingshow = true;
  }

  adicionalesList() {
    if (!this.aplicanteCurrent?.adicionales) return [];
    return this.aplicanteCurrent.adicionales.filter(a => 
      (a.numero_documento && a.numero_documento.toString().trim() !== '') || 
      (a.nombre_completo && a.nombre_completo.toString().trim() !== '')
    );
  }

  public searchScByProduct(tar: any) {
    var combo = tar as HTMLSelectElement;
    this.productOk = true;

    let source = this.sourcecodesList.data.find(s => s.prod == tar.value
      && s.promotor == this.aplicanteCurrent.detalles.promotor_original
      && Number(Utils.getTimesTamp(this.aplicanteCurrent.detalles.fecha)) <= Number(Utils.getTimesTamp(s.final_effective_date))
      && Number(Utils.getTimesTamp(this.aplicanteCurrent.detalles.fecha)) >= Number(Utils.getTimesTamp(s.initial_effective_date))
      && s.subchannel == this.aplicanteCurrent.solicitud_tarjeta.subchannel
    );

    if (source) {
      this.aplicanteCurrent.solicitud_tarjeta.application_source = source.source_code_completo;
      this.aplicanteCurrent.detalles.sourceCode = source.source_code_completo;
      this.aplicanteCurrent.detalles.sourceCodeDescripcion = source.descripcion;
      this.objSc = source;
      this.productOk = true;
    } else {
      this.aplicanteCurrent.solicitud_tarjeta.application_source = "";
      this.aplicanteCurrent.detalles.sourceCode = "";
      this.aplicanteCurrent.detalles.sourceCodeDescripcion = "";
      this.objSc = { "descripcion": "" };
      this.productOk = false;
    }
  }

  mapGenero(key: string) {
    return this.generosList.data.find(i => i.key == key)?.value;
  }

  adicionalesEditar(dni: any) {
    let adicional = this.aplicanteCurrent.adicionales.find((a) => {
      return a.numero_documento == dni;
    });

    let adicionalBk = this.aplicanteCurrent.adicionales.find((a) => {
      return a.numero_documento == dni;
    });

    this.adicionalCurrent = Object.assign({}, adicional);
    this.adicionalCurrentBk = adicional;
    this.adicionalCurrent.crud = adicionalBk ? CRUD.UPDATE : CRUD.CREATE;

    this.showAdicionalesEditar = true;
    return true;
  }

  adicionalesNuevo() {
    let adicionales = this.aplicanteCurrent.adicionales.filter(a => 
      a.crud != CRUD.DELETE && 
      ((a.numero_documento && a.numero_documento.toString().trim() !== '') || 
       (a.nombre_completo && a.nombre_completo.toString().trim() !== ''))
    );
    if (adicionales.length >= 5) {
      this.alertMessage = new AlertModel("Solo se permiten hasta 5 adicionales.", this.title, true, ALERT_TYPE.INFO);
      return false;
    }

    this.adicionalCurrent = new AplicanteAdicionalModel();
    this.adicionalCurrentBk = null;
    this.adicionalCurrent.crud = CRUD.CREATE;
    this.showAdicionalesEditar = true;

    return true;
  }

  adicionalesCancelar() {
    this.showAdicionalesEditar = false;
    this.adicionalCurrent = null;
    this.validationsAdicionalShow = false;
    this.validationsAdicional = [];
  }

  adicionalesGuardar() {
    if (!this.validationsAdcionalForm()) {
      this.validationsAdicionalShow = true;
      return false;
    }

    this.adicionalCurrent.numero_documento = this.adicionalCurrent.numero_documento.replace(/[^0-9]+/, "");

    let adicional = this.aplicanteCurrent.adicionales.find((a) => {
      return a.numero_documento == this.adicionalCurrent.numero_documento &&
        a.crud != CRUD.DELETE;
    });

    let dniChangeCurrent = adicional && !this.adicionalCurrentBk ? adicional.numero_documento == this.adicionalCurrent.numero_documento : false;
    let dniChangeOriginal = adicional && this.adicionalCurrentBk ? this.adicionalCurrentBk.numero_documento != this.adicionalCurrent.numero_documento : false;

    if (dniChangeCurrent || dniChangeOriginal) {
      this.alertMessage = new AlertModel("Ya existe un adicional con el mismo número documento.", this.title, true, ALERT_TYPE.INFO);
      return false;
    }

    if (adicional || this.adicionalCurrentBk) {
      let index = this.aplicanteCurrent.adicionales.indexOf(adicional ?? this.adicionalCurrentBk);
      this.aplicanteCurrent.adicionales[index] = Object.assign({}, this.adicionalCurrent);
      this.aplicanteCurrent.adicionales[index].usuario = this.sessionStorageService.getCurrentUser().username;
    } else {
      this.adicionalCurrent.usuario = this.sessionStorageService.getCurrentUser().username;
      this.aplicanteCurrent.adicionales.push(this.adicionalCurrent);
    }

    this.adicionalCurrentBk = null;
    this.showAdicionalesEditar = false;
    this.saveAdicionales();
    return true;
  }

  adicionalesBorrarConfirm(confirm: any) {
    if (confirm.confirm) {
      let adicional = this.aplicanteCurrent.adicionales.find((a) => {
        return a.numero_documento == confirm.data;
      });
      let index = this.aplicanteCurrent.adicionales.indexOf(adicional);
      this.aplicanteCurrent.adicionales[index].crud = CRUD.DELETE;
      this.saveAdicionales();
    }
  }

  adicionalesBorrar(dni: any) {
    this.alertConfirmEvent = this.adicionalesBorrarConfirm;
    this.alertMessage = new AlertModel("Esta acción eliminará el siguiente registro: " + dni + "\nEsta seguro de continuar?", this.title, true, "CONFIRM", dni);
  }

  saveAdicionales() {
    let aplicante: any = new Object;
    aplicante.usuario = this.sessionStorageService.getCurrentUser()?.username;
    aplicante.promotor = this.sessionStorageService.getCurrentUser()?.promotor;
    aplicante.solicitud_tarjeta = this.aplicanteCurrent.solicitud_tarjeta;
    aplicante.datos_personales = this.aplicanteCurrent.datos_personales;
    aplicante.datos_contacto = this.aplicanteCurrent.datos_contacto;
    aplicante.datos_laborales = this.aplicanteCurrent.datos_laborales;
    aplicante.detalles = this.aplicanteCurrent.detalles;
    aplicante.datos_precheck = this.aplicanteCurrent.datos_precheck || {};
    aplicante.adicionales = this.aplicanteCurrent.adicionales || [];
    aplicante.observaciones = this.aplicanteCurrent.observaciones;
    // Si no se cambió el estado (accion vacía), enviar la validación original para no sobreescribir
    if (this.aplicanteCurrent.validacion && this.aplicanteCurrent.validacion.accion) {
      aplicante.validacion = this.aplicanteCurrent.validacion;
    } else {
      aplicante.validacion = this.aplicanteCurrent.validacionOriginal || this.aplicanteCurrent.validacion;
    }

    this.canceladosService.saveApplicant(aplicante).subscribe(
      data => {
        if (data && data['code'] == '0') {
          this.alertMessage = new AlertModel("Adicional guardado con éxito.", this.title, true, "SUCCESS");
        } else {
          this.alertMessage = new AlertModel("Hubo un inconveniente al guardar el adicional.", this.title, true);
        }
      },
      error => {
        console.error(error);
        this.alertMessage = new AlertModel("Hubo un inconveniente al guardar el adicional.", this.title, true);
      }
    );
  }

  validationsAdcionalForm() {
    this.validationsAdicional = [];

    if (Utils.isNullOrEmpty(this.adicionalCurrent.numero_documento))
      this.validationsAdicional.push({ "adicionalCurrent.numero_documento": "este campo es requerido." });

    if (Utils.isNullOrEmpty(this.adicionalCurrent.nombre_completo))
      this.validationsAdicional.push({ "adicionalCurrent.nombre_completo": "este campo es requerido." });

    if (Utils.isNullOrEmpty(this.adicionalCurrent.nombre_primero))
      this.validationsAdicional.push({ "adicionalCurrent.nombre_primero": "este campo es requerido." });

    if (Utils.isNullOrEmpty(this.adicionalCurrent.apellido_primero))
      this.validationsAdicional.push({ "adicionalCurrent.apellido_primero": "este campo es requerido." });

    if (Utils.isNullOrEmpty(this.adicionalCurrent.fecha_nacimiento))
      this.validationsAdicional.push({ "adicionalCurrent.fecha_nacimiento": "este campo es requerido." });

    if (!Utils.isNullOrEmpty(this.adicionalCurrent.fecha_nacimiento)) {
      let b = moment(this.adicionalCurrent.fecha_nacimiento, "DD/MM/YYYY");
      if (moment().diff(b, 'years') < 14)
        this.validationsAdicional.push({ "adicionalCurrent.fecha_nacimiento": "no se permite menor a 14 años" });
    }

    if (this.vinculosList.data.find(v => v.key == this.adicionalCurrent.vinculo) == null) {
      this.adicionalCurrent.vinculo = "";
      this.validationsAdicional.push({ "adicionalCurrent.vinculo": "este campo es requerido." });
    }

    if (this.generosList.data.find(v => v.key == this.adicionalCurrent.genero) == null) {
      this.adicionalCurrent.genero = "";
      this.validationsAdicional.push({ "adicionalCurrent.genero": "este campo es requerido." });
    }

    return this.validationsAdicional.length == 0;
  }

  validationsAdcionalMessage(key: string) {
    let v = this.validationsAdicional.find(i => i[key] != null);
    return v ? v[key] : null;
  }
}
